module.exports = __webpack_public_path__ + "img/1.f37e42c1.gif";